__turbopack_context__.v({
  "body": "MeasureAccordion-module__fIGGMW__body",
  "icon": "MeasureAccordion-module__fIGGMW__icon",
  "icons": "MeasureAccordion-module__fIGGMW__icons",
  "indicator": "MeasureAccordion-module__fIGGMW__indicator",
  "indicatorSlot": "MeasureAccordion-module__fIGGMW__indicatorSlot",
  "item": "MeasureAccordion-module__fIGGMW__item",
  "label": "MeasureAccordion-module__fIGGMW__label",
  "labelRow": "MeasureAccordion-module__fIGGMW__labelRow",
  "linkRow": "MeasureAccordion-module__fIGGMW__linkRow",
  "panel": "MeasureAccordion-module__fIGGMW__panel",
  "panelInner": "MeasureAccordion-module__fIGGMW__panelInner",
  "trigger": "MeasureAccordion-module__fIGGMW__trigger",
  "wrap": "MeasureAccordion-module__fIGGMW__wrap",
});
